import { makeRPCPost } from '~api/RpcAPI/RpcAPI';

import { IOrderObject, IPGResponse } from '~api/CartAPI/ICartApiSdk';
import { IUpdateReplenishmentPayload } from '~api/ReplenismentAPI/IReplenishmentAPI';

interface IUpdateReplenishment {
    REPLENISHMENT_FREQ: number;
    SKU_BASE_ID: string;
    COLLECTION_ID?: string;
    action: string;
    _SUBMIT: string;
    _TOKEN: string;
}

export const _updateReplenishment = ({
    SKU_BASE_ID,
    REPLENISHMENT_FREQ,
    COLLECTION_ID,
    _TOKEN
}: IUpdateReplenishmentPayload) => {
    const body = [
        {
            method: 'rpc.form',
            params: [
                {
                    REPLENISHMENT_FREQ,
                    SKU_BASE_ID,
                    COLLECTION_ID,
                    action: 'add',
                    _SUBMIT: 'alter_replenishment',
                    _TOKEN
                }
            ]
        }
    ];

    return makeRPCPost<IUpdateReplenishment, IPGResponse<IOrderObject>>(body, _TOKEN);
};
